/*
  Floating header — homepage only (see highrise-floating-header.css for
  why this only ever loads there). Two independent jobs:

  1. Toggle `.is-scrolled` on the header itself, ourselves, rather than
     reading Dawn's own `.scrolled-past-header` (set by the StickyHeader
     class in sections/header.liquid). That class comes from an
     IntersectionObserver measuring `.section-header`'s own box — which
     this page deliberately collapses to ~0 height (the header is
     `position: fixed` from the very first frame here, never reserving
     flow space, so the hero starts at the true top of the viewport).
     A visitor who scrolls immediately — which automated testing does
     reliably, and real visitors often do too — can fire the first
     'scroll' event before that observer's async callback has reported
     real bounds; Dawn's onScroll still runs, but with `headerBounds`
     still `{}`, every comparison against `headerBounds.bottom`/`.top`
     is `x > undefined`, which is always false, so nothing toggles —
     and critically, `currentScrollTop` still gets updated unconditionally
     at the end of that same call, permanently consuming the one state
     transition Dawn's logic needed to ever see. The class then never
     gets set for the rest of the session. A plain scrollY threshold,
     with no async measurement to race, sidesteps that entirely.

  2. Wire up open/close for the nav sub-bubble. The toggle button + panel
     already exist in the DOM sitewide (inert, hidden by default) — this
     wires up open/close. Cart access moved out of the header entirely
     (see the floating "buy now" bar, highrise-buy-bar.js) in favor of a
     plain account link, so there's no cart sub-bubble to wire up here.
*/
(function () {
  var SCROLL_THRESHOLD = 24;

  function initScrollState() {
    var header = document.querySelector('.header-wrapper.highrise-home-header--floating');
    if (!header) return;

    /* The floating header is sitewide now, but the transparent "top"
       state (see :not(.is-scrolled) in highrise-floating-header.css)
       only makes visual sense layered over a hero image/video — on any
       page without one (most of them), a visitor would see the bar
       fully transparent over whatever plain content happens to be at
       the top of that page, before immediately jumping to the bubble
       on their first scroll pixel. Skip straight to the bubble instead
       on those pages — no transparent state to transition out of.
       `.hn-floating-hero` is a shared marker class any qualifying hero
       section carries (currently the homepage's video hero and the shop
       page's flavor-compare slider) — not the specific `.highrise-home-
       hero` class, since that also carries that section's own unrelated
       styling and a second hero type shouldn't have to inherit it just
       to be found here. */
    if (!document.querySelector('.hn-floating-hero')) {
      /* Also drops position:fixed (see highrise-floating-header.css) —
         fixed-positioned over a page with no tall hero to justify it
         would just permanently cover whatever's at the top of that
         page's content instead of reserving normal flow space for
         itself, the way every other header on this page type expects. */
      header.classList.add('is-scrolled', 'highrise-home-header--static');
      return;
    }

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initMenu() {
    var menuToggle = document.querySelector('[data-float-menu-toggle]');
    var menu = document.querySelector('[data-float-menu]');
    if (!menuToggle || !menu) return;

    function closeMenu() {
      menu.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
    }
    function openMenu() {
      menu.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');
    }

    menuToggle.addEventListener('click', function () {
      menu.hidden ? openMenu() : closeMenu();
    });

    document.addEventListener('click', function (event) {
      if (!menu.hidden && !menu.contains(event.target) && !menuToggle.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!menu.hidden) {
        closeMenu();
        menuToggle.focus();
      }
    });

    var header = document.querySelector('.header-wrapper.highrise-home-header--floating');
    window.addEventListener('scroll', function () {
      if (header && !header.classList.contains('is-scrolled')) closeMenu();
    }, { passive: true });
  }

  function init() {
    initScrollState();
    initMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
